import React, { useState } from "react";
import { ListingVariationFormData } from "api/listingAPI";
import { Table, Button, Input, InputProps, Confirm } from "semantic-ui-react";
import { Size } from "api/types";

interface VariationTableProps {
  variations: ListingVariationFormData[];
  onRemoval: (id: number | undefined, color: string, size: Size) => void;
  onQtyChange: Function;
}

const VariationTable: React.FC<VariationTableProps> = ({
  variations,
  onRemoval,
  onQtyChange,
}) => {
  const [confirmOpenIndex, setConfirmOpenIndex] = useState<number | undefined>(
    undefined
  );

  const handleQtyChange = (color: string, size: Size, data: InputProps) => {
    console.log(color, size, data.value);
    onQtyChange(color, size, data.value);
  };

  const handleRemoval = (id: number | undefined, color: string, size: Size) => {
    setConfirmOpenIndex(undefined);
    onRemoval(id, color, size);
  };

  const renderVariations = () => {
    if (variations === undefined || variations.length === 0) {
      return (
        <Table.Row>
          <Table.Cell rowSpan="5">No variations yet.</Table.Cell>
        </Table.Row>
      );
    }
    return variations.map((v: ListingVariationFormData, index) => {
      return (
        <Table.Row key={v.color + v.size}>
          <Table.Cell width="3">{v.color}</Table.Cell>
          <Table.Cell width="3">{v.size}</Table.Cell>
          <Table.Cell width="3">{v.pack}</Table.Cell>
          <Table.Cell width="3">{v.packBreakdown}</Table.Cell>
          <Table.Cell width="3">
            <Input
              type="number"
              onChange={(_, data) => handleQtyChange(v.color, v.size, data)}
              value={v.qty}
            />
          </Table.Cell>
          <Table.Cell width="1" textAlign="center">
            <Button
              icon="remove"
              size="tiny"
              negative
              compact
              onClick={() => setConfirmOpenIndex(index)}
            />
            <Confirm
              header="Are you sure?"
              content="This action cannot be undone."
              open={confirmOpenIndex === index}
              size="mini"
              onCancel={() => setConfirmOpenIndex(undefined)}
              onConfirm={() => handleRemoval(v.id, v.color, v.size)}
              confirmButton={<Button content="Delete" negative />}
            />
            {/* <DeleteConfirmation
             *   trigger={
             *     <Button
             *       icon="remove"
             *       color="red"
             *       size="tiny"
             *       compact
             *       onClick={() => setIsConfirmOpen(true)}
             *     />
             *   }
             *   open={isConfirmOpen}
             *   onClose={() => setIsConfirmOpen(false)}
             *   onConfirm={() => onRemoval(v.id, v.color, v.size)}
             * /> */}
          </Table.Cell>
        </Table.Row>
      );
    });
  };

  return (
    <Table celled compact striped>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Color</Table.HeaderCell>
          <Table.HeaderCell>Size</Table.HeaderCell>
          <Table.HeaderCell>Pack</Table.HeaderCell>
          <Table.HeaderCell>Pack Breakdown</Table.HeaderCell>
          <Table.HeaderCell>Qty in Packs</Table.HeaderCell>
          <Table.HeaderCell></Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>{renderVariations()}</Table.Body>
    </Table>
  );
};

export default VariationTable;
